import React, { Component, Fragment, useEffect } from 'react';
// import { Link } from 'react-router-dom';
import cx from '../../../styles';
// import style from './style.css';
import Modal from 'react-modal';
import { translate } from 'react-i18next';
import {Icon} from '../../Common/Icon';
import Loader from '../../Common/Loader';
import EmailLogin from '../EmailLogin';
// import CONFIG from '../../../config';
// import ForgotPassword from '../forgotPassword';
import {getUrlImage, gtmSend} from '../../../helpers';
import { template } from '../../../config'

const customStyles = {
  content : {
      top                   : '50%',
      left                  : '50%',
      right                 : 'auto',
      bottom                : 'auto',
      marginRight           : '-50%',
      transform             : 'translate(-50%, -50%)',
      width                 : '820px'
  }
};

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
if(typeof window != 'undefined') {
    Modal.setAppElement('#root');
}

class LoginModal extends Component {

    constructor(props) {
        super(props);
        this.state = {isModalOpen: false, isActive: false, isResetActive: false, isNewUser: false};
    }

    onAfterOpen = () => {
        this.setState({isModalOpen: true});
    }

    onModalClose = () => {
        this.setState({isModalOpen: false});
        this.props.onModalClose();
    }

    onEmailClick = (value) => {
        this.setState({isActive: value, isNewUser: false});
    }

    onGetStartedClick = () => {
        this.setState({isActive: true, isNewUser: true});
        gtmSend('dynamic', 'Get Started', 'click', this.props.mode === 'inlineBooth' ?  'booth login popup' : 'login popup');
        gtmSend('login_popup_option_selection', 'Login Popup', 'Get Started', '--', 0, {action: 'Get Started'});
    }

    onCloseEmail = () => {
        this.setState({isActive: false});
    }

    onResetClick = (value) => {
        this.setState({isResetActive: value});
    }

    render() {
        const t = this.props.t;
        return (
            <Fragment>
                <Modal isOpen={this.props.isModalOpen}
                    onAfterOpen={this.onAfterOpen}
                    onRequestClose={this.onModalClose}
                    overlayClassName="myOverlayClass"
                    style={customStyles} >

                    {
                        this.props.mode === 'inline' &&
                        <Inline t={t}
                            socialLoginButtons={this.props.socialLoginButtons}
                            onModalClose={this.onModalClose}
                            onEmailClick={this.onEmailClick}
                            onResetClick={this.onResetClick} 
                            isResetActive={this.state.isResetActive}
                            isActiveEmailLogin={this.state.isActive}
                            isNewUser={this.state.isNewUser}
                            emailCheck={this.props.emailCheck}
                            onEmailLogin={this.props.onEmailLogin} 
                            onForgotPassword={this.props.onForgotPassword}
                            isLoading={this.props.isLoading}
                            onGetStartedClick={this.onGetStartedClick}
                            onCloseEmail={this.onCloseEmail}
                            match={this.props.match}/>
                    }

                    {
                        this.props.mode === 'inlineBooth' &&
                        <InlineBooth t={t}
                            socialLoginButtons={this.props.socialLoginButtons}
                            onModalClose={this.onModalClose}
                            onEmailClick={this.onEmailClick} 
                            isActiveEmailLogin={this.state.isActive}
                            isNewUser={this.state.isNewUser}
                            emailCheck={this.props.emailCheck}
                            onEmailLogin={this.props.onEmailLogin}
                            onResetClick={this.onResetClick}
                            isResetActive={this.state.isResetActive}
                            onForgotPassword={this.props.onForgotPassword}
                            isLoading={this.props.isLoading}
                            onGetStartedClick={this.onGetStartedClick}
                            onCloseEmail={this.onCloseEmail}
                            match={this.props.match}/>
                    }
                </Modal>
            </Fragment>
        );
    }

}
const Inline = (props) => {
    const {socialLoginButtons, onModalClose, onEmailClick, t, onGetStartedClick} = props;

    useEffect(() => {
        gtmSend('dynamic', 'Login Popup', 'open', props.match.path);
    },[]);

    return (
        <div className={cx("login-modal", template)}>
            <span className={cx("close-modal")} onClick={()=>{onModalClose(); gtmSend('login_popup_close', 'Login Popup', 'Close', '--', 0, {action: 'Close'});}}>
                <Icon className={cx("not-mobile")} name="close-regular-black-sm" />
                <Icon className={cx("only-mobile")}  name="cross-regular-dark-smd" />
            </span>
            <div className={cx("login-section")}>
                <div className={cx('ls-top')}>
                    <h2>{t('login_main_title')}</h2>
                    <p>{t('login_quality_answers')}</p>
                </div>

                <div className={cx("ls-body")}>
                    <h2>{t('login_with')}</h2>

                    <div className={cx('main-section')}>
                        <div className={cx("button-wrap")}>
                            {
                                socialLoginButtons.map((Button, i) => {
                                    return <Button key={i} />;
                                })
                            }

                            <div className={cx('email-icon')} onClick={() => {onEmailClick(true); gtmSend('login_popup_option_selection', 'Login Popup', 'Login with: Email', '--', 0, {action: 'Login with: Email'})}}>
                                <Icon name="email-icon" />
                            </div>
                        </div>
                        <div>{t('or')}</div>
                        <div className={cx('get-started-btn')} onClick={onGetStartedClick}>
                            <span>{t('get_started')}</span>
                            <Icon name="right-arrow-btn" />
                        </div>
                        {/*<div className={cx("")} onClick={() => onEmailClick(true)}>
                            {
                                navigator.userAgent.indexOf('Firefox') === -1 
                                ?
                                <input className={cx("open-email-input")} name="input_user_email" type="text" placeholder={t('email')} autoComplete="off" disabled/>
                                :
                                <input className={cx("open-email-input")} name="input_user_email" type="text" placeholder={t('email')} autoComplete="off" readOnly/>
                            }
                        </div>*/}
                    </div>
                        <p>{t('login_we_dont_post')}</p>
                        <p><a onClick={()=>{gtmSend('login_popup_option_selection', 'Login Popup', 'Terms & Conditions', '--', 0, {action: 'Terms & Conditions'})}} href='/privacy' target="_blank">{t('terms_and_conditions')}</a></p>

                </div>
            </div>
             <div className={cx("login-footer-container not-mobile", props.isActiveEmailLogin ? 'hide' : '')}>
                            <div className={cx("footer-left-text")}>
                                <p>{t('login_footer_title')}</p>
                            </div>
                            <div className={cx("footer-country-flag")}>
                                <div className={cx("flag-icons")}>
                                    <div>
                                        <em className={cx("flag-icons-sprite flag-singapore")}></em>
                                        <p>Singapore</p>
                                    </div>
                                </div>
                                <div className={cx("flag-icons")}>
                                    <div>
                                        <em className={cx("flag-icons-sprite flag-philippines")}></em>
                                        <p>Philippines</p>
                                    </div>
                                </div>
                                <div className={cx("flag-icons")}>
                                    <div>
                                        <em className={cx("flag-icons-sprite flag-indonesia")}></em>
                                        <p>Indonesia</p>
                                    </div>
                                </div>
                                <div className={cx("flag-icons")}>
                                    <div>
                                        <em className={cx("flag-icons-sprite flag-thailand")}></em>
                                        <p>Thailand</p>
                                    </div>
                                </div>
                                <div className={cx("flag-icons")}>
                                    <div>
                                        <em className={cx("flag-icons-sprite flag-malaysia")}></em>
                                        <p>Malaysia</p>
                                    </div>
                                </div>
                                <div className={cx("flag-icons")}>
                                    <div>
                                        <em className={cx("flag-icons-sprite flag-vietnam")}></em>
                                        <p>Vietnam</p>
                                    </div>
                                </div>                             
                            </div>
                        </div>
                        {
                            props.isActiveEmailLogin && 
                            <EmailLogin
                                onEmailLogin={props.onEmailLogin}
                                onCloseEmail={props.onCloseEmail}
                                emailCheck={props.emailCheck}
                                isNewUser={props.isNewUser}
                                onForgotPassword={props.onForgotPassword} />
                        }
                        {props.isLoading && <Loader />}
        </div>
    );
}

const InlineBooth = (props) => {
    const {socialLoginButtons, onModalClose, onEmailClick, t, onGetStartedClick} = props;

    return (
        <div className={cx("login-modal", template)}>
            <span className={cx("close-modal")} onClick={()=>{onModalClose(); gtmSend('login_popup_close', 'Login Popup', 'Close', '--', 0, {action: 'Close'});}}>
                <Icon className={cx("not-mobile")} name="close-regular-black-sm" />
                <Icon className={cx("only-mobile")}  name="cross-regular-dark-smd" />
            </span>

            <div className={cx("login-section")}>

                <div className={cx("ls-body", "photobooth-modal-body")}>
                    <div className={cx("photobooth-social-media-login-wrap")}>
                        <h2>{t('login_into_view_the_photo')}</h2>
                        
                        <div className={cx('main-section')}>
                            <div className={cx("button-wrap")}>
                                {
                                    socialLoginButtons.map((Button, i) => {
                                        return <Button key={i} />;
                                    })
                                }

                                <div className={cx('email-icon')} onClick={() => onEmailClick(true)}>
                                    <Icon name="email-icon" />
                                </div>
                            </div> 
                            <div>{t('or')}</div>
                            <div className={cx('get-started-btn')} onClick={onGetStartedClick}>
                                <span>{t('get_started')}</span>
                                <Icon name="right-arrow-btn" />
                            </div>
                            {/*<div onClick={() => onEmailClick(true)}>
                                {
                                    navigator.userAgent.indexOf('Firefox') === -1 
                                    ?
                                    <input className={cx("open-email-input")} name="input_user_email" type="text" placeholder={t('email')} autoComplete="off" disabled/>
                                    :
                                    <input className={cx("open-email-input")} name="input_user_email" type="text" placeholder={t('email')} autoComplete="off" readOnly/>
                                }
                            </div>*/}     
                        </div>
                            <Fragment>
                                <p className={cx("we-dont-post-italic")}>
                                    {t('login_we_dont_post')}
                                </p>

                                <p className={cx("gap-between-sl-qr-code")}>
                                    {t('or')}
                                </p>

                                <p>
                                    <strong>
                                        {t('download_the_number_one_rated_parenting_app')}
                                    </strong>
                                </p>
                            </Fragment>

                        <div className={cx("app-download-link-wrap")}>
                            <div className={cx("qr-code-img")}></div>
                                <div className={cx("app-download-button")}>
                                        <a href="https://community.theasianparent.com/app/download?utm_source=booth-login&utm_medium=web&utm_campaign=app-download" className={cx("app-store-app-button")}>
                                            <img src={getUrlImage({imgPath: 'prod-beyeu-assets/community/icon-ios.svg', defaultImgPath: 'html-edm/2018/sep/tap-welcome/icon-ios.svg'})} alt="app store" loading="lazy" />
                                        </a>
                                        <a href="https://community.theasianparent.com/app/download?utm_source=booth-login&utm_medium=web&utm_campaign=app-download" className={cx("google-play-app-button")}>
                                            <img src={getUrlImage({imgPath: 'prod-beyeu-assets/community/icon-android.svg', defaultImgPath: 'html-edm/2018/sep/tap-welcome/icon-android.svg'})} alt="google play store" loading="lazy" />
                                        </a>
                                </div>
                            <div className={cx("clear-fix")}></div>
                        </div>
                    </div>
                    {
                        // <div className={cx('photobooth-mobile-img-wrap')}>
                        //     <div className="photobooth-mobile-img"></div>
                        // </div>
                        // <div className={cx("clear-fix")}></div>
                    }

                </div>
            </div>
            {
                props.isActiveEmailLogin && 
                <EmailLogin
                    onEmailLogin={props.onEmailLogin}
                    onCloseEmail={props.onCloseEmail}
                    emailCheck={props.emailCheck}
                    isNewUser={props.isNewUser}
                    onForgotPassword={props.onForgotPassword} />
            }
            {props.isLoading && <Loader />}
        </div>
    );
}

export default translate()(LoginModal);
